// src/utils/axiosInstance.js

import axios from 'axios';

// Create an Axios instance with a base URL
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_STRAPI_API_URL || 'https://sglm-api.turinix.com/api',
});

export default axiosInstance;